module.exports = "pegasus_template/assets/themecapture1/charity/105.png";